{% block sw_cms_block_acris_blog_image %}
    <div class="sw-cms-block-acris-blog-image">
        <slot name="column"></slot>
    </div>
{% endblock %}
